<template>
  <div id="OrderDetails">
    <div class="topContent">
      <div class="left">
        <span>客户单号:</span>
        <el-input clearable v-model="aaa"></el-input>
      </div>
      <div class="right">
        <el-button> 导出</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    ></table-plug>
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
  </div>
</template>
<script>
import TablePlug from "@/components/Modules/TablePlug.vue";
import paging from "@/components/pagings.vue";
export default {
  components: {
    TablePlug,
    paging,
  },
  data() {
    return {
      aaa: "",
      totalArr: [],
      // 表格配置
      tableConfig: {
        tableHeigth: "78vh",
        tableData: [
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
          {
            a: "测试数据",
            b: "测试数据",
            c: "测试数据",
          },
        ],
      },
      myTableHeard: [
        {
          name: "收支单据号",
          field: "a",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "责任部门",
          field: "b",
          sort: 4,
          isShow: true,
        },
        {
          name: "收支类型",
          field: "c",
          sort: 5,
          isShow: true,
        },
        {
          name: "单据类型",
          field: "billStorepackNumber",
          sort: 5,
          isShow: true,
        },
        {
          name: "来源单据",
          field: "billStorepackChannelNumber",
          sort: 6,
          isShow: true,
        },
        {
          name: "费项",
          field: "frameName",
          sort: 1,
          isShow: true,
        },
        {
          name: "结算对象",
          field: "packageStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "金额",
          field: "storepackStatusShow",
          sort: 18,
          isShow: true,
        },
        {
          name: "备注",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "审核状态",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "审核人",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "审核时间",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "核销人",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "核销状态",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "核销时间",
          field: "isRejectionShow",
          sort: 19,
          isShow: true,
        },
        {
          name: "资金账号",
          field: "checkStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "核销备注",
          field: "checkStatusShow",
          sort: 1,
          isShow: true,
        },
      ],
      // 分页的props
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
    };
  },
  created() {},
  methods: {
    // // 表格选择事件
    handleSelectionChange(e) {
      console.log("表格选择事件");
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    // 分页的方法
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
  },
};
</script>
<style scoped lang="less">
#OrderDetails {
  .topContent {
    display: flex;
    justify-content: space-between;
    padding: 16px 80px;
    .left {
      display: flex;
      border: 1px #cccccc solid;
      height: 30px;
      border-radius: 4px;
      text-align: right;
      span {
        width: 100px;
        line-height: 30px;
        color: #606266;
        font-size: 14px;
      }
      /deep/.el-input__inner {
        height: 30px;
        line-height: 30px;
        border: none;
      }
    }
    .right {
      .el-button {
        padding: 8px 20px;
      }
      .el-button:hover {
        background: #fff;
        border: 1px solid #ef7c0a;
        color: #ef7c0a;
      }
    }
  }
}
</style>
